import React from "react";

export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white" data-testid="loading-screen">
      <div className="flex items-center gap-4 select-none animate-fade-in">
        <span className="text-6xl leading-none" role="img" aria-label="crow">
          🐦‍⬛
        </span>
        <span
          className="text-black font-extrabold tracking-tight"
          style={{ fontFamily: "Manrope, sans-serif", fontSize: 64, letterSpacing: "-0.04em" }}
        >
          CROW
        </span>
      </div>
      <style>{`
        @keyframes fade-in {
          from { opacity: 0; transform: scale(0.96); }
          to   { opacity: 1; transform: scale(1); }
        }
        .animate-fade-in { animation: fade-in 0.6s ease-out; }
      `}</style>
    </div>
  );
}
